var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.7268 3.07849L12.7067 14.7027H5.2282L4.20833 3.07849L2.91602 3.19177L3.95452 15.0268C4.00917 15.5723 4.48248 16 5.03233 16H12.9026C13.4522 16 13.9257 15.5726 13.9813 15.019L15.0191 3.19177L13.7268 3.07849Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.3457 0H6.58891C5.99278 0 5.50781 0.484969 5.50781 1.08109V3.13516H6.80509V1.29728H11.1294V3.13512H12.4267V1.08106C12.4267 0.484969 11.9418 0 11.3457 0Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.8849 2.48651H2.04709C1.68881 2.48651 1.39844 2.77689 1.39844 3.13517C1.39844 3.49345 1.68881 3.78382 2.04709 3.78382H15.8849C16.2432 3.78382 16.5336 3.49345 16.5336 3.13517C16.5336 2.77689 16.2432 2.48651 15.8849 2.48651Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0.966797)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.f55148aa04cfac4d7d40ba31c2393cb1.svg";
export { ForwardRef as ReactComponent };